import ArchivosAdjuntos from './ArchivosAdjuntos';

export default ArchivosAdjuntos;
